import type { Money } from "@/shared/value-objects/money.vo";
import type { Row } from "@tanstack/react-table";

export const monetaryFilterFn = <R>(
  row: Row<R>,
  columnId: string,
  filterValue: [number | undefined, number | undefined],
) => {
  const [min, max] = filterValue;

  const cellValue = row.getValue<Money>(columnId);

  if (typeof min === "number" && typeof max === "number") {
    return cellValue.amount >= min && cellValue.amount <= max;
  }

  if (typeof min === "number") {
    return cellValue.amount >= min;
  }

  if (typeof max === "number") {
    return cellValue.amount <= max;
  }

  return false;
};
